import React from "react";
import { toast } from "react-toastify";
import { FaCheckCircle } from "react-icons/fa";
import { FaCircleExclamation } from "react-icons/fa6";

export const errorMessage = (msg) => {
  toast.error(msg, {
    icon: <FaCircleExclamation color="red" size={20} />,
    position: "top-center",
    closeOnClick: true,
    hideProgressBar: false,
    pauseOnHover: true,
    draggable: true,
    autoClose: 1000,
  });
};

export const successMessage = (msg) => {
  toast.success(msg, {
    // position: "top-center",
    icon: <FaCheckCircle color="#07bc0c" size={20} />,
    position: "top-center",
    closeOnClick: true,
    hideProgressBar: false,
    pauseOnHover: true,
    draggable: true,
    autoClose: 1000,
  });
};
